module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-bnxt1",
    attrs: {
      "id": "calibre_pb_19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "quote-red"
  }), _vm._v(" "), _c('p', {
    staticClass: "quote-red"
  }, [_vm._v("FlavCity changed the way I read labels! I dreaded reading labels before. I never paid attention to the added sugars, natural flavors, or types of oils, and didn’t understand what expeller pressed meant! Thanks to FlavCity, reading labels is much easier now and takes less time.")]), _vm._v(" "), _c('p', {
    staticClass: "quote-a-red"
  }, [_vm._v("—Mariam A.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_20"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fdd00ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_010.vue
// module id = 87
// module chunks = 0